import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {ClassifierMapping} from '../../../models/classifier-mapping.interface';
import {KfConfigurationSummaryData} from '../../../models/kf-configuration-summary-data.interface';
import {CountryYear} from '../../../models/country-year.interface';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';

@Component({
  selector: 'app-kf-configuration-summary-table',
  templateUrl: './kf-configuration-summary-table.component.html',
  styleUrls: ['./kf-configuration-summary-table.component.scss']
})
export class KfConfigurationSummaryTableComponent implements OnChanges {

  displayedColumns!: string[];
  dataSource: KfConfigurationSummaryData[] = [];

  @Input()
  countryYears!: CountryYear[];
  @Input()
  summaryMappings!: ClassifierMapping[];
  @Input()
  classifierType!: string;
  @Input()
  showEmptyValues!: boolean;
  @Output()
  downloadExcelFile: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  loadData: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnChanges(): void {
    this.displayedColumns = ['classifier', 'unuKey'];
    if (this.countryYears) {
      this.countryYears.forEach(c => {
        if (this.showEmptyValues) {
          this.displayedColumns.push(c.countryCode + ' (' + (c.year || '____') + ')');
        } else {
          if (c.year) {
            this.displayedColumns.push(c.countryCode + ' (' + (c.year) + ')');
          }
        }
      });
    }
    this.displayedColumns.push('total');

    if (this.summaryMappings) {
      this.summaryMappings.forEach((element) => {
          const unuKeysSize = element.mappings.length;
          element.mappings.forEach((mapping, index) => {
            const item = {} as KfConfigurationSummaryData;
            item.classifierRowSpan = index === 0 ? unuKeysSize : 0;
            item.classifier = element.classifier.description;
            item.unuKey = mapping.unuKey.description;
            let countMappings = 0;
            mapping.countries.forEach(({code, mapped}) => {
              item[code] = mapped;
              if (mapped) {
                countMappings++;
              }
            });
            item.total = countMappings;
            this.dataSource.push(item);
          });
        }
      );
    }
  }

  downloadExcel(): void {
    this.downloadExcelFile.emit(this.showEmptyValues);
  }

  loadSummaryMappings(event: MatSlideToggleChange): void {
    this.loadData.emit(event.checked);
  }

  getCountryCodeFromHeader(countryColumn: string): string {
    return countryColumn.split(' ')[0];
  }
}
